import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import { request } from "@/js/http/http_request";
import { isAdminNotConsultant, getLimitedLocations, hasRole, getClientAppData } from "@/js/http/auth.js";
import { getErrorData } from "@/js/forms.js";
import { paging, defaultPagingChoices, emptyCellContent } from "@/js/lists.ts";
import Paging from "@/components/paging/PagingComponent.vue";
import WarehousePopin from "@/components/warehouse/WarehousePopin.vue";
import Index from "@/components/paging/IndexComponent.vue";
import DefaultDeparturePopin from "@/components/warehouse/DefaultDeparturesPopin.vue";
import Confirm from "@/components/modal/ConfirmationDialog.vue";
export default {
  name: "WarehouseList",
  components: {
    Paging: Paging,
    WarehousePopin: WarehousePopin,
    Index: Index,
    DefaultDeparturePopin: DefaultDeparturePopin,
    Confirm: Confirm
  },
  props: {
    loggedUserData: Object
  },
  data: function data() {
    return {
      clientAppData: null,
      canEditDefaultDepartureContinent: false,
      searchCriterias: {
        paging: {
          limits: paging.DEFAULT,
          currentPage: 0,
          askedPage: 0
        },
        label: null
      },
      pagingLimitsChoices: defaultPagingChoices,
      countries: [],
      states: [],
      datatable_headers: [{
        text: "Name",
        value: "name",
        align: "center"
      }, {
        text: "Mail",
        value: "mail",
        align: "center"
      }, {
        text: "FR Invoice",
        value: "isPreventInvoice",
        align: "center"
      }, {
        text: "Storage Country",
        value: "address.country.printable_name",
        align: "center"
      }, {
        text: "Intended Countries",
        value: "defaultIntendedCountries",
        align: "center"
      }, {
        text: "Inbound",
        value: "isInboundCompatible",
        align: "center"
      }, {
        text: "Actions",
        value: "action",
        align: "center"
      }],
      isLoadingList: true,
      datatable_items: [],
      numberOfPages: null,
      warehousesCount: null,
      warehousePopinShown: true,
      reloadWarehouseDefaultDeparturePopinShown: false,
      managedExceptions: {
        warning: {
          warehouse_already_deleted: "The warehouse is already deleted.",
          warehouse_used_in_default_departure: "The warehouse is still in use in defaults departures.",
          warehouse_used_in_stock: "The warehouse is still in use in some stocks."
        }
      },
      emptyCellContent: emptyCellContent
    };
  },
  computed: {
    hasResult: function hasResult() {
      return !this.isLoadingList && this.datatable_items.length > 0;
    }
  },
  created: function created() {
    this.canEditDefaultDepartureContinent = hasRole(process.env.VUE_APP_ROLES_MANAGE_WAREHOUSES_DEFAULT_DEPARTURES);
    this.clientAppData = getClientAppData(this);
    var _this = this;
    request("/v1/countries?implantedMarket=true", "post", _this.clientAppData, false, "api").then(function (response) {
      _this.countries = _toConsumableArray(response.data.countries);
      _this.states = _toConsumableArray(response.data.states);
    }).catch(function (err) {
      _this.$toasted.show("An error occured. Please contact an administrator.", {
        type: "error"
      });
    });
    if (isAdminNotConsultant(_this.loggedUserData)) {
      this.fetchWarehouses();
    }
  },
  methods: {
    fetchWarehouses: function fetchWarehouses() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _this;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this2.$EventBus.$emit("loading", true);
              _this2.isLoadingList = true;
              _this = _this2;
              _context.next = 5;
              return request("/v1/warehouses", "post", _this.searchCriterias, true, "api").then(function (response) {
                _this.datatable_items = response.data.warehouses;
                _this.warehousesCount = response.data.total_number;
                _this.numberOfPages = Math.ceil(_this.warehousesCount / _this.searchCriterias.paging.limits);
                _this.searchCriterias.paging.currentPage = _this.searchCriterias.paging.askedPage + 1;
              }).catch(function (e) {
                _this.$toasted.show("Unable to load warehouses", {
                  type: "error"
                });
              });
            case 5:
              _this2.isLoadingList = false;
              _this2.$EventBus.$emit("loading", false);
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    search: function search() {
      var isResetPaging = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (isResetPaging) this.resetPaging();
      this.fetchWarehouses();
    },
    resetPaging: function resetPaging() {
      this.searchCriterias.paging.askedPage = 0;
    },
    changePage: function changePage(askedPage) {
      if (askedPage >= 0 && askedPage <= this.numberOfPages) {
        this.searchCriterias.paging.askedPage = askedPage;
        this.fetchWarehouses();
        window.scrollTo(0, 0);
      }
    },
    openNewWarehousePopin: function openNewWarehousePopin() {
      var _this3 = this;
      this.warehousePopinShown = true;
      this.$nextTick(function () {
        _this3.$refs.warehousePopin.open();
      });
    },
    openEditWarehousePopin: function openEditWarehousePopin(item) {
      var _this4 = this;
      this.warehousePopinShown = true;
      this.$nextTick(function () {
        _this4.$refs.warehousePopin.openEdit(item);
      });
    },
    closeWarehousePopin: function closeWarehousePopin(response) {
      this.warehousePopinShown = false;
      if (response.confirmed) {
        this.reloadWarehouseDefaultDeparturePopinShown = !this.reloadWarehouseDefaultDeparturePopinShown;
        this.fetchWarehouses();
      }
    },
    openDefaultDeparturePopin: function openDefaultDeparturePopin() {
      this.$refs.DefaultDeparturePopin.open();
    },
    canEditWarehouse: function canEditWarehouse(item) {
      var limitedLocations = getLimitedLocations(this.loggedUserData);
      if ((limitedLocations === null || limitedLocations === void 0 ? void 0 : limitedLocations.length) > 0) {
        return limitedLocations.some(function (loc) {
          var _item$address$state;
          return loc.state_id > 0 ? item.address.country.id_country === loc.country_id && ((_item$address$state = item.address.state) === null || _item$address$state === void 0 ? void 0 : _item$address$state.id_state) === loc.state_id : item.address.country.id_country === loc.country_id;
        });
      }
      return true;
    },
    isDeletionAvailable: function isDeletionAvailable(item) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _response$data$wareho;
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this = _this5;
              _context2.next = 3;
              return request("/v1/warehouse/".concat(item.id_warehouse, "/stocks"), "get", {}, true, "api").catch(function (e) {
                _this.$toasted.show("Unable to load this warehouse", {
                  type: "error"
                });
                return false;
              });
            case 3:
              response = _context2.sent;
              if (!(response.data.totalNumberStocks > 0)) {
                _context2.next = 7;
                break;
              }
              _this.$toasted.show("Please, remove all existing stocks before deleting this warehouse.", {
                type: "warning"
              });
              return _context2.abrupt("return", false);
            case 7:
              if (!(((_response$data$wareho = response.data.warehouse.defaultDepartures) === null || _response$data$wareho === void 0 ? void 0 : _response$data$wareho.length) > 0)) {
                _context2.next = 10;
                break;
              }
              _this.$toasted.show("Please, change all defaults departures before deleting this warehouse.", {
                type: "warning"
              });
              return _context2.abrupt("return", false);
            case 10:
              return _context2.abrupt("return", true);
            case 11:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    deleteWarehouse: function deleteWarehouse(item) {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var isAvailable, confirmed, _this;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this6.isDeletionAvailable(item);
            case 2:
              isAvailable = _context3.sent;
              if (!isAvailable) {
                _context3.next = 13;
                break;
              }
              _context3.next = 6;
              return _this6.$refs.confirm.open("Delete", "Are you sure you want to delete this warehouse?", {
                color: "red"
              });
            case 6:
              confirmed = _context3.sent;
              if (!confirmed) {
                _context3.next = 13;
                break;
              }
              _this = _this6;
              _context3.next = 11;
              return request("/v1/warehouse/".concat(item.id_warehouse), "delete", null, true, "api").catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions);
                _this.$toasted.show(errorData.message, {
                  type: errorData.type
                });
              });
            case 11:
              _this6.reloadWarehouseDefaultDeparturePopinShown = !_this6.reloadWarehouseDefaultDeparturePopinShown;
              _this6.search(true);
            case 13:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    isAdminNotConsultant: isAdminNotConsultant
  }
};